<ng-container *ngIf="!discount">
  {{service.euro(amount)}}
</ng-container>
<ng-container *ngIf="discount">
  <del>{{service.euro(amount)}}</del>
  {{service.euro(amount - (discount.percentage / 100 * amount))}}
  <span class="info-icon">
    <mat-icon [matTooltip]="discount.reason">info_outline</mat-icon>
  </span>
</ng-container>
